module.exports = __webpack_public_path__ + "img/kj6.dac5a400.png";